import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import TeamSetCard from "./TeamSetCard";

/**
 * TeamSetSection — one variation band (gold / blue / white).
 *
 * `products` is the up-to-12 featured list resolved server-side from
 * Shopify (via a Shopify tag / metafield / collection ordering — TBD
 * on catalog import). When `products` is empty, we render a polished
 * "Coming Soon" empty state instead of fake products.
 */
export default function TeamSetSection({
  id, eyebrow, heading, description, products = [],
  variation, viewAllHref, viewAllLabel,
  accentClass = "",
}) {
  const has = Array.isArray(products) && products.length > 0;
  const featured = has ? products.slice(0, 8) : [];

  return (
    <section id={id} className={`container-gm py-14 md:py-20 scroll-mt-32 ${accentClass}`}
             data-testid={`team-set-section-${variation}`}>
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <div className="kicker kicker-red">{eyebrow}</div>
          <h2 className="h-display text-3xl md:text-5xl mt-3">{heading}</h2>
          {description && (
            <p className="text-[var(--smoke)] max-w-2xl mt-3">{description}</p>
          )}
        </div>
      </div>

      {!has ? (
        <div className="rounded-3xl border-2 border-dashed border-[var(--ink)]/25 bg-white p-10 md:p-14 text-center"
             data-testid={`team-set-section-empty-${variation}`}>
          <div className="kicker kicker-red">FULL TEAM SETS COMING SOON</div>
          <p className="mt-4 text-lg text-[var(--smoke)] max-w-xl mx-auto">
            The complete 20-sticker {variation === "gold" ? "Gold Crumple" : variation === "blue" ? "Blue Parallel" : "White Original"} team sets will be available shortly. Sign in to be notified.
          </p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5"
               data-testid={`team-set-grid-${variation}`}>
            {featured.map((p) => (
              <TeamSetCard key={p.shopify_product_id || `${variation}-${p.country_code}`}
                           product={{ ...p, variation }} />
            ))}
          </div>
          <div className="flex justify-center mt-10">
            <Link to={viewAllHref} className="btn-ghost"
                  data-testid={`team-set-view-all-${variation}`}>
              {viewAllLabel} <ArrowRight size={16} />
            </Link>
          </div>
        </>
      )}
    </section>
  );
}
